"use client";

import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
const slides = [{
  id: 1,
  badge: "TẦM NHÌN",
  titleStart: "NUCETECH",
  highlight: "Đổi Mới",
  titleEnd: "Xây Dựng",
  description: "Tiên phong trong nghiên cứu, chuyển giao công nghệ và đổi mới sáng tạo ngành xây dựng tại Việt Nam.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_hero_construction.png",
  ctaText: "Về chúng tôi",
  ctaLink: "/AboutUsPage"
}, {
  id: 2,
  badge: "CÔNG NGHỆ",
  titleStart: "Chuyển Đổi Số",
  highlight: "Thông Minh",
  titleEnd: "",
  description: "Cung cấp các giải pháp kỹ thuật số tiên tiến giúp tối ưu hóa hiệu quả dự án xây dựng.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/digital_transformation_site.png",
  ctaText: "Giải pháp",
  ctaLink: "/SolutionsPage"
}, {
  id: 3,
  badge: "CHUYÊN GIA",
  titleStart: "Hợp Tác",
  highlight: "Phát Triển",
  titleEnd: "Bền Vững",
  description: "Kết nối sức mạnh tri thức từ Đại học Xây dựng Hà Nội để giải quyết các thách thức thực tiễn.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/expert_consulting_team.png",
  ctaText: "Liên hệ ngay",
  ctaLink: "/ContactPage"
}];
export default function VisionInnovationConstruction() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section id="tầm-nhìn-đổi-mới-xây-dựng" className="relative w-full overflow-hidden bg-background ![margin:10px_0px_10px_0px] !h-[500px]">
      <div className="relative w-full h-full bg-[radial-gradient(circle_at_center,var(--primary)/5,transparent_70%)] border-y border-primary/10">
        <Carousel setApi={setApi} className="w-full h-full">
          <CarouselContent className="h-full -ml-0">
            {slides.map((slide, index) => <CarouselItem key={slide.id} data-index={index} className="pl-0 h-full relative min-w-0 shrink-0 grow-0 basis-full">
                {}
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out" style={{
              backgroundImage: `url(${slide.image})`
            }} />
                
                {}
                <div className="absolute inset-0 bg-black/30" />

                {}
                <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 max-w-6xl mx-auto !h-[450px]">
                  {}
                  <Badge className="mb-6 bg-[var(--ring)] text-white hover:bg-[var(--ring)]/90 border-none px-4 py-1.5 text-sm font-bold uppercase tracking-widest shadow-lg">
                    {slide.badge}
                  </Badge>

                  {}
                  <h2 className="text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight text-white mb-6 font-sans drop-shadow-lg">
                    {index === 0 ? "NUCETECH" : <>
                        {slide.titleStart}{" "}
                        <span className="text-primary [text-shadow:_-2px_-2px_0_#fff,_2px_-2px_0_#fff,_-2px_2px_0_#fff,_2px_2px_0_#fff]">
                          {slide.highlight}
                        </span>{" "}
                        {slide.titleEnd}
                      </>}
                  </h2>

                  {}
                  <p className="text-lg md:text-2xl text-white/95 max-w-3xl font-medium drop-shadow-md leading-relaxed">
                    {slide.description}
                  </p>

                  {}
                  <div className="mt-10">
                    <Button asChild size="lg" className="h-14 px-8 text-lg bg-[var(--ring)] hover:bg-[var(--ring)]/80 text-white border-none shadow-xl transition-all hover:scale-105">
                      <Link to={slide.ctaLink}>
                        {slide.ctaText}
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex gap-3 z-20">
            {Array.from({
            length: count
          }).map((_, index) => <Button key={index} data-index={index} variant="ghost" className={cn("h-3 rounded-lg transition-all duration-300 shadow-sm p-0 hover:bg-white", index === current ? "bg-[var(--ring)] w-10" : "bg-white/60 w-3")} onClick={() => api?.scrollTo(index)} aria-label={`Go to slide ${index + 1}`} />)}
          </div>
        </Carousel>
      </div>
      {}
      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-primary via-accent to-transparent z-30" />
    </section>;
}